/**
 * Header & Mobile Navigation Module
 */
(function() {
  'use strict';

  function initHeader() {
    const header = document.getElementById('site-header');
    const toggleBtn = document.getElementById('mobile-menu-toggle');
    const drawer = document.getElementById('mobile-drawer');
    const overlay = document.getElementById('mobile-drawer-overlay');
    const openIcon = toggleBtn ? toggleBtn.querySelector('.menu-open-icon') : null;
    const closeIcon = toggleBtn ? toggleBtn.querySelector('.menu-close-icon') : null;

    if (!header) return;

    // Scroll state handler
    function handleScroll() {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    // Mobile Drawer Toggle
    if (toggleBtn && drawer) {
      function toggleMenu(isOpen) {
        const expanded = typeof isOpen === 'boolean' ? isOpen : toggleBtn.getAttribute('aria-expanded') !== 'true';
        toggleBtn.setAttribute('aria-expanded', expanded.toString());
        drawer.setAttribute('aria-hidden', (!expanded).toString());

        if (expanded) {
          drawer.classList.add('is-open');
          if (overlay) {
            overlay.classList.add('is-open');
            overlay.classList.remove('opacity-0', 'pointer-events-none');
            overlay.classList.add('opacity-100', 'pointer-events-auto');
          }
          document.body.classList.add('overflow-hidden');
          document.documentElement.classList.add('overflow-hidden');
          if (openIcon) openIcon.classList.add('hidden');
          if (closeIcon) closeIcon.classList.remove('hidden');
        } else {
          drawer.classList.remove('is-open');
          if (overlay) {
            overlay.classList.remove('is-open');
            overlay.classList.remove('opacity-100', 'pointer-events-auto');
            overlay.classList.add('opacity-0', 'pointer-events-none');
          }
          document.body.classList.remove('overflow-hidden');
          document.documentElement.classList.remove('overflow-hidden');
          if (openIcon) openIcon.classList.remove('hidden');
          if (closeIcon) closeIcon.classList.add('hidden');
        }
      }

      toggleBtn.addEventListener('click', function() {
        toggleMenu();
      });

      // Close mobile drawer when clicking backdrop overlay
      if (overlay) {
        overlay.addEventListener('click', function() {
          toggleMenu(false);
        });
      }

      // Close mobile drawer when clicking anchor links
      const mobileLinks = drawer.querySelectorAll('a');
      mobileLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          const href = link.getAttribute('href');
          if (!href || href === '#' || href === 'javascript:void(0)') {
            e.preventDefault();
            return;
          }
          toggleMenu(false);
        });
      });

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && toggleBtn.getAttribute('aria-expanded') === 'true') {
          toggleMenu(false);
          toggleBtn.focus();
        }
      });
    }

    // Mobile Submenu Accordion
    if (drawer) {
      const mobileToggles = drawer.querySelectorAll('.mobile-submenu-toggle');
      mobileToggles.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          const parentItem = btn.closest('.mobile-nav-item, .mobile-sub-item');
          const submenu = parentItem ? Array.from(parentItem.children).find(function(el) {
            return el.classList.contains('mobile-submenu');
          }) : null;
          const arrow = btn.querySelector('.mobile-arrow');

          btn.setAttribute('aria-expanded', (!expanded).toString());

          if (submenu) {
            submenu.classList.toggle('is-open', !expanded);
            submenu.classList.toggle('hidden', expanded);
          }
          if (arrow) {
            arrow.style.transform = !expanded ? 'rotate(180deg)' : '';
          }
        });
      });
    }

    // Desktop: keyboard open/close submenus
    const desktopNav = document.getElementById('desktop-nav');
    if (desktopNav) {
      const hasSubmenus = desktopNav.querySelectorAll('.has-submenu');
      hasSubmenus.forEach(function(link) {
        link.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const item = link.closest('.nav-item');
            const sub = item ? item.querySelector('.submenu') : null;
            if (sub) {
              const isOpen = sub.style.opacity === '1';
              sub.style.opacity = isOpen ? '' : '1';
              sub.style.visibility = isOpen ? '' : 'visible';
              sub.style.pointerEvents = isOpen ? '' : 'auto';
              sub.style.transform = isOpen ? '' : 'translateY(0)';
            }
          }
          if (e.key === 'Escape') {
            const item = link.closest('.nav-item');
            const sub = item ? item.querySelector('.submenu') : null;
            if (sub) {
              sub.style.opacity = '';
              sub.style.visibility = '';
              sub.style.pointerEvents = '';
              sub.style.transform = '';
              link.focus();
            }
          }
        });
      });

      // Close desktop submenus on outside click
      document.addEventListener('click', function(e) {
        if (!desktopNav.contains(e.target)) {
          desktopNav.querySelectorAll('.submenu').forEach(function(sub) {
            sub.style.opacity = '';
            sub.style.visibility = '';
            sub.style.pointerEvents = '';
            sub.style.transform = '';
          });
        }
      });
    }

    // Language Dropdown Toggle
    const langDropdowns = document.querySelectorAll('.lang-dropdown');
    langDropdowns.forEach(function(dropdown) {
      const btn = dropdown.querySelector('.lang-btn');
      if (btn) {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          const isOpen = dropdown.classList.contains('is-open');
          langDropdowns.forEach(function(d) {
            d.classList.remove('is-open');
            const b = d.querySelector('.lang-btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            dropdown.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });

    document.addEventListener('click', function(e) {
      langDropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
          const btn = dropdown.querySelector('.lang-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  window.GinaHeader = { init: initHeader };
})();
